<template>
  <div class="imports-page">
    <h1>Imports page</h1>
  </div>
</template>

<script>
export default {
  name: "ImportsPage"
};
</script>

<style>
</style>